// One file per UI area so parallel migrations and upstream rebases touch disjoint files.
// Keys are globally unique (`com_<area>_*`); scripts/check-catalogs.mjs rejects duplicates.
import agent from "./agent.json"
import app from "./app.json"
import auth from "./auth.json"
import automation from "./automation.json"
import chat from "./chat.json"
import core from "./core.json"
import entity from "./entity.json"
import extras from "./extras.json"
import home from "./home.json"
import market from "./market.json"
import nav from "./nav.json"
import obs from "./obs.json"
import session from "./session.json"
import settings from "./settings.json"
import skill from "./skill.json"
import ui from "./ui.json"

const translation = {
    ...core,
    ...ui,
    ...nav,
    ...auth,
    ...home,
    ...agent,
    ...chat,
    ...session,
    ...settings,
    ...automation,
    ...skill,
    ...market,
    ...entity,
    ...obs,
    ...app,
    ...extras,
}

export default translation
